import AwesomeDebouncePromise from 'awesome-debounce-promise';

const debounce = (fn: any, wait: number = 300) =>
  AwesomeDebouncePromise(fn, wait);

export default debounce;
